import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig"; // adjust path if needed

export const logActivity = async ({ userId, userName, companyId, action, module, details }) => {
  try {
    await addDoc(collection(db, "activityLogs"), {
      timestamp: serverTimestamp(),
      userId,
      userName,
      companyId,
      action,   // e.g. "CREATE", "UPDATE", "DELETE", "LOGIN"
      module,   // e.g. "Task", "Project", "Login", "Signup"
      details   // additional info
    });
  } catch (error) {
    console.error("❌ Error logging activity:", error);
  }
};
